"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCEPTED_TAB_SOURCE_FILES_EXTENSIONS = exports.isNumericColumnType = exports.LayoutType = exports.TabSourceType = exports.isGroupLayoutConfig = exports.isTabLayoutConfig = exports.OrderType = exports.DatasourcesToTabTypes = exports.ScopedTypes = exports.ReasonsType = exports.ColumnType = exports.TabType = void 0;
const datasource_1 = require("../datasource");
__exportStar(require("./groups"), exports);
var TabType;
(function (TabType) {
    TabType["SOURCE"] = "source";
    TabType["GROUP_BY"] = "group_by";
    TabType["UNION"] = "union";
    TabType["JOIN"] = "join";
    TabType["FILTER"] = "filter";
    TabType["PULL"] = "pull";
    TabType["WEBHOOK"] = "webhook";
    TabType["BIG_QUERY"] = "big_query";
    TabType["PLAN_UNION"] = "plan_union";
    TabType["MANUAL"] = "manual";
    TabType["USER"] = "user";
    TabType["UNION_V2"] = "union_v2";
    TabType["PAYMENT"] = "payment";
})(TabType = exports.TabType || (exports.TabType = {}));
var ColumnType;
(function (ColumnType) {
    ColumnType["BOOLEAN"] = "boolean";
    ColumnType["STRING"] = "string";
    ColumnType["NUMBER"] = "number";
    ColumnType["INTEGER"] = "int";
    ColumnType["CURRENCY"] = "currency";
    ColumnType["ERROR"] = "error";
    ColumnType["DATE"] = "date";
    ColumnType["SERIAL_DATE"] = "serial_date";
    ColumnType["EMPTY"] = "empty";
    ColumnType["JSON"] = "json";
})(ColumnType = exports.ColumnType || (exports.ColumnType = {}));
var ReasonsType;
(function (ReasonsType) {
    ReasonsType["TAB_UPDATED"] = "tab_updated";
    ReasonsType["SOURCE_TAB_DELETED"] = "source_tab_deleted";
    ReasonsType["CLONED_TAB"] = "cloned_tab";
})(ReasonsType = exports.ReasonsType || (exports.ReasonsType = {}));
var ScopedTypes;
(function (ScopedTypes) {
    ScopedTypes["DATASOURCE"] = "datasource";
    ScopedTypes["TAB"] = "tab";
    ScopedTypes["COLUMN"] = "column";
})(ScopedTypes = exports.ScopedTypes || (exports.ScopedTypes = {}));
exports.DatasourcesToTabTypes = {
    [datasource_1.DatasourceTypes.GOOGLE_SHEETS]: TabType.SOURCE,
    [datasource_1.DatasourceTypes.SPREAD_SHEETS]: TabType.SOURCE,
    [datasource_1.DatasourceTypes.GROUP_BY]: TabType.GROUP_BY,
};
var OrderType;
(function (OrderType) {
    OrderType["ASC"] = "ASC";
    OrderType["DESC"] = "DESC";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
const isTabLayoutConfig = (cfg) => {
    return cfg.type === 'tab';
};
exports.isTabLayoutConfig = isTabLayoutConfig;
const isGroupLayoutConfig = (cfg) => {
    return cfg.type === 'group';
};
exports.isGroupLayoutConfig = isGroupLayoutConfig;
var TabSourceType;
(function (TabSourceType) {
    TabSourceType["BIG_QUERY"] = "bigquery";
    TabSourceType["MYSQL"] = "mysql";
    TabSourceType["CALC_ON_BIGQUERY"] = "calc_on_bigquery";
})(TabSourceType = exports.TabSourceType || (exports.TabSourceType = {}));
var LayoutType;
(function (LayoutType) {
    LayoutType["DEFAULT"] = "default";
    LayoutType["SOURCES"] = "sources";
})(LayoutType = exports.LayoutType || (exports.LayoutType = {}));
const isNumericColumnType = (c) => c ? [ColumnType.CURRENCY, ColumnType.NUMBER, ColumnType.INTEGER].includes(c) : false;
exports.isNumericColumnType = isNumericColumnType;
exports.ACCEPTED_TAB_SOURCE_FILES_EXTENSIONS = ['xlsx', 'xls', 'csv', 'do', 'xml', 'xltx'];
